import React, { useState } from 'react';
import { message } from 'antd';
import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import UploadImage from './UploadImage';
import { emoticonApis } from 'apis/resource/emoticonApis';
import InputStyled from 'components/InputStyled';
/**
 * * 리소스 - 배경 수정 모달
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;
  data: any;
  setData: React.Dispatch<any>;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  projectId: string | undefined;
}

const EmoticonAssetEditModal = ({
  visible,
  setVisible,
  data,
  setData,
  setRefresh,
  refresh,
  projectId,
}: IProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    setVisible(false);
  };
  const [loading, setLoading] = useState<boolean>(false);
  /// 서버 전송
  const handleSubmit = async () => {
    if (data) {
      const postData = {
        update: data,
      };
      try {
        setLoading(true);
        await emoticonApis.emoticonAssetEditName(
          projectId,
          data.emoticon_id,
          data.id,
          postData,
        );
        setRefresh(!refresh);
        setVisible(false);
        setLoading(false);
        handleMessage(message, 'success', 'Success');
      } catch (err) {
        console.log('update error', err);
        setLoading(false);
        handleMessage(message, 'error', 'Error');
      }
    }
  };

  const handleInputChange = (value, type: string) => {
    if (data) {
      const cloneData = JSON.parse(JSON.stringify(data));
      cloneData[type] = value;
      setData(cloneData);
    }
  };
  return (
    <DefaultModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.emoticonContent.editEmoticonModal.title',
      )}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <HeaderWrapper>
          <p>ID: {data?.id}</p>
        </HeaderWrapper>
        <FormWrapper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.emoticonContent.createGroupModal.name',
              )}
            </p>
            <InputStyled
              value={data?.image_name}
              onChange={(e) => {
                handleInputChange(e.target.value, 'image_name');
              }}
              maxLength={30}
            />
            <p className='length-subtext'>
              {typeof data?.image_name?.length === 'number'
                ? `${data?.image_name?.length}/30 characters`
                : '0/30 characters'}
            </p>
          </div>
          <UploadImage
            data={data}
            setData={setData}
            projectId={projectId}
            title='Minicut Image'
            hideRequired={true}
          />
        </FormWrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default EmoticonAssetEditModal;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;

const FormWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
